import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-diagnostic-view',
  templateUrl: './diagnostic-view.component.html',
  styleUrl: './diagnostic-view.component.scss'
})
export class DiagnosticView {
  @Input() filters?: Record<string, any[]> | null = null;

  constructor(private translate: TranslateService) {}

  formatTime(result: any): string {
    if (!result) return '';

    const hours = parseInt(result.hours || '0');
    const minutes = parseInt(result.minutes || '0');
    const seconds = parseInt(result.seconds || '0');

    const parts: string[] = [];

    if (hours > 0) {
      const hourKey = hours === 1 ? 'ANALYTICS.HOUR' : 'ANALYTICS.HOURS';
      parts.push(`${hours} ${this.translate.instant(hourKey)}`);
    }
    if (minutes > 0) {
      const minuteKey = minutes === 1 ? 'ANALYTICS.MINUTE' : 'ANALYTICS.MINUTES';
      parts.push(`${minutes} ${this.translate.instant(minuteKey)}`);
    }
    if (seconds > 0 || parts.length === 0) {
      const secondKey = seconds === 1 ? 'ANALYTICS.SECOND' : 'ANALYTICS.SECONDS';
      parts.push(`${seconds} ${this.translate.instant(secondKey)}`);
    }

    return parts.join(' ');
  }
}
